<template>
    <div class="preview-template">

        <div class="preview-template__bubble">

            <div v-if="hasMedia" class="preview-template__media">
                <img v-if="hasImageMedia" :src="template.media[0].url" alt="Media">
                <div v-if="hasPDFMedia" class="preview-template__media__embed-wrapper" :style="{ '--embed-height': normalizedHeight }">
                    <embed :src="template.media[0].url" type="application/pdf"/>
                </div>
                <!-- <template v-if="hasPDFMedia"><embed :src="template.media[0].url" type="application/pdf" width="100%" height="600px" /></template> -->
            </div>
            
            <div v-html="previewContentHTML"></div>
            
            <div v-if="hasActions">
                <div v-for="(action, index) in template.actions" v-bind:key="index" class="preview-template__footer">
                    <div class="preview-template__footer--form-invite">
                        <a v-bind:href="action.url" target="_blank">
                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        {{action.title}}
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div> 
</template>

<script>
    import {whatsAppTemplateMixin} from '../../mixins/WhatsAppTemplateMixin'

    export default {
        name: 'PreviewTemplate',
        components: {},
        mixins: [whatsAppTemplateMixin],
        props: {
            template: {
                type: Object,
                required: true
            },
            embedHeight: {
                type: [String, Number],
                default: '600px'
            }
        },
        data() {
            return {
            };
        },
        computed: {
            previewContentHTML: function() {
                return this.previewTemplateContentHTML(this.template);
            },
            normalizedHeight() {
                return typeof this.embedHeight === 'number'
                ? `${this.embedHeight}px`
                : this.embedHeight
            }
        },
        methods: {
        },
        mounted() {
        },
        beforeUnmount() {
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../styles/components/_preview_template.scss";
</style>